export default __webpack_public_path__ + "static/media/controls.ac4f9a03.png";